export default $client => ({
  verify(txid, exchangeId) {
    return $client.post(`transactions/${txid}/verify`, {
      exchange_id: exchangeId
    });
  },
});
